export enum SubActionTypes {
  API_RESPONSE_SUCCESS = "@@sub/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@sub/API_RESPONSE_ERROR",

  GET_SUB = "@@sub/GET_SUB",
  DELETE_SUB = "@@sub/DELETE_SUB",
}
